import { REMOVE_MESSAGE, SET_MESSAGE } from '../Types/contactTypes';

const intialState = {
    msg : ""
}

const contactReducer = (state = intialState, action) => {
    if(action.type === SET_MESSAGE)
    {
        state = {
            ...state,
            msg : action.payload
        }
    }
    else if(action.type === REMOVE_MESSAGE)
    {
        state = {
            ...state,
            msg : ""
        }
    }
    
    return state;
}

export default contactReducer;